import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';

import { $Elements, Durations, Events } from './constants';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Slideshow ----------

	$('.content-section').each(function() {

		const section = this;

		$(section).find('.section-slideshow, .column-slideshow').each(function() {

			const slideshow = this;

			if(!slideshow.swiper) {

				const swiper = new Swiper(slideshow, {
					speed: Durations.animations.ms,
					loop: true,
					observer: true,
					autoplay: true,
					effect: 'fade',
					modules: [Autoplay, EffectFade, Navigation, Pagination],
					fadeEffect: {
						crossFade: true,
					},
					pagination: {
						el: section.querySelector('.swiper-pagination'),
					},
					navigation: {
						nextEl: section.querySelector('.swiper-button-next'),
						prevEl: section.querySelector('.swiper-button-prev'),
					},
				});
			}
		});
	});

	// --------- Teams Section --------

	$('.team-section').each(function() {

		const filterButtons = document.querySelectorAll('.filters-list .filters-item');
		const fonctionsBlocks = document.querySelectorAll('.members-lists .fonctions');

		if(!filterButtons.length || !fonctionsBlocks.length) return;

		filterButtons.forEach((button) => {
			button.addEventListener('click', () => {
				const fonctionKey = button.getAttribute('data-fonction');

				filterButtons.forEach((btn) => btn.classList.remove('active'));
				button.classList.add('active');

				fonctionsBlocks.forEach((block) => {
					if(block.getAttribute('data-fonction') === fonctionKey) {
						block.classList.add('active');
					}
					else {
						block.classList.remove('active');
					}
				});
			});
		});
	});


	// -------- Dates Carousel ------------

	$('.dates-section').each(function() {

		const section = this;

		const dates = Array.from(
			section.querySelectorAll('.swiper-slide .date')
		).map(el => el.textContent.trim());

		$(section).find('.section-carousel, .column-carousel').each(function() {

			const carousel = this;

			if(!carousel.swiper) {
				let MAX_VISIBLE;

				if(window.innerWidth >= 1024) {
					MAX_VISIBLE = 7;
				}
				else {
					MAX_VISIBLE = 4;
				}

				window.addEventListener('resize', () => {
					MAX_VISIBLE = (window.innerWidth >= 1024) ? 7 : 4;
					updateTimelineBullets(swiper);
				});

				const updateTimelineBullets = (swiper) => {
					const bullets = swiper.pagination.bullets;
					const total = bullets.length;
					if(!bullets || !total) return;

					const max = Math.min(MAX_VISIBLE, total);
					const half = Math.floor(max / 2);
					let center = swiper.realIndex;

					let start = center - half;
					let end = center + half;

					if(start < 0) {
						end += -start;
						start = 0;
					}

					if(end > total - 1) {
						const diff = end - (total - 1);
						start = Math.max(0, start - diff);
						end = total - 1;
					}

					bullets.forEach((bullet, index) => {
						if(index >= start && index <= end) {
							bullet.classList.add('is-visible');
						}
						else {
							bullet.classList.remove('is-visible');
						}
					});
				};


				const swiper = new Swiper(carousel, {
					speed: Durations.animations.ms,
					loop: false,
					observer: true,
					modules: [Navigation, Pagination, EffectFade],
					pagination: {
						el: section.querySelector('.swiper-pagination'),
						clickable: true,
						renderBullet: function(index, className) {
							const label = dates[index] || index + 1;
							return `
							<button type="button"
								class="${className}"
								aria-label="Go to year ${label}">
								<p class="bullet-date">${label}</p>
							</button>
						`;
						},
					},
					effect: 'fade',
					navigation: {
						nextEl: section.querySelector('.swiper-button-next'),
						prevEl: section.querySelector('.swiper-button-prev'),
					},
					on: {
						init(swiper) {
							updateTimelineBullets(swiper, true);
						},
						slideChange(swiper) {
							updateTimelineBullets(swiper, false);
						},
					},
				});
			}
		});

	});


	// -------- Posts Carousel ------------

	$('.other-posts-section').each(function() {

		const section = this;

		$(section).find('.section-carousel, .column-carousel').each(function() {

			const carousel = this;

			if(!carousel.swiper) {

				const swiper = new Swiper(carousel, {
					speed: Durations.animations.ms,
					loop: false,
					observer: true,
					modules: [Pagination],
					slidesPerView: 'auto',
					spaceBetween: 30,
					autoHeight: false,
					grabCursor: true,
					pagination: {
						el: section.querySelector('.swiper-pagination'),
						clickable: true,
						renderBullet: function(index, className) {
							return `
							<button type="button" class="${className}">
								${index + 1}
							</button>
						`;
						},
					},
				});
			}
		});
	});
});
